import { AppConfig } from "./types/AppConfig"

export const APP_CONFIG = {
    // @ts-ignore
    appName: process.env.REACT_APP_APP_NAME as string,//getOrThrow('APP_NAME'),
    backendURL: process.env.REACT_APP_BACKEND_URL,//getOrThrow('BACKEND_URL'),
    // @ts-ignore
    isDebug: JSON.parse(process.env.REACT_APP_IS_DEBUG as string),//getOrThrow('IS_DEBUG', JSON.parse) as any as boolean,
    defaultLanguage: process.env.REACT_APP_DEFAULT_LANGUAGE,//getOrThrow('DEFAULT_LANGUAGE'),
    enableCalls: true,
    enableSMS: true,
} satisfies AppConfig